import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=c2586abc&scoped=true&"
var script = {}
import style0 from "./Label.vue?vue&type=style&index=0&id=c2586abc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2586abc",
  null
  
)

export default component.exports